export default {
  OK: "đồng ý",
  CLOSE: "Tài khoản đã bị đóng !",
  BLOCK: "Tài khoản đã bị khoá !",
  passwordRequired: "Mật khẩu bị bắt buộc !",
  usernameRequired: "Tên đăng nhập bị bắt buộc !",

  session_not_exists: "Phiên hết hạn! Hãy đăng nhập lại để tiếp tục ...",
  session_expired: "Phiên hết hạn! Hãy đăng nhập lại để tiếp tục ...",
  invalidSession: "Phiên hết hạn! Hãy đăng nhập lại để tiếp tục ...",
  accountIdRequired: "Phiên hết hạn! Hãy đăng nhập lại để tiếp tục ...",
  NoUserAccessRight: "Quyền truy cập bị từ chối ! Vui lòng liên hệ cấp trên để được tiếp tục...",
  account_not_exists: "Mật khẩu không hợp lệ.",
  invalid_password: "Mật khẩu không hợp lệ.",
  secondary_account_exists: "Biệt danh của bạn đã được khởi tạo .",
  systemError: "Hệ thống nội bộ lỗi .",
  new_login_id_exists: "Biệt danh không hiệu lực . Vui lòng cài đặt biệt danh khách .",
  loginLimit: "Bạn đã đăng nhập quá thường xuyên, hãy thử lại sau 1 phút ...",
  requestLimit: "Bạn gửi yêu cầu quá nhiều.",
  unableToGetBalanceAtTheMoment: "Lỗi máy chủ nội bộ.",
  oddsDisplayInvalid: "Tỷ lệ hiển thị không hợp lệ.",
  oddsIsUpdating: "Tỷ lệ đang cập nhật ...",
  atLeastTwoMatchToBetParlay: "Phải có ít nhất 2 trận đấu để được cược xiên với nhau.",
  atLeastThreeMatchToBetParlay: "Ít nhất phải kết hợp ba trận đấu để đặt cược theo cược xiên.",
  duplicate_debit_record: "Tỷ lệ đang cập nhật ...",

  insufficient_balance: "Số dư không đủ",
  betOverMaxPerMatch: "Phần thầu của bạn đã vượt mức phần thầu tối đa.",
  betOverMax: "Phần thầu của bạn đã vượt mức phần thầu tối đa.",
  betOverMaxBet: "Phần thầu của bạn đã vượt mức phần thầu tối đa.",
  betLowerMin: "Phần thầu của bạn ít hơn mức phần thầu tối thiểu.",

  loginFailed: "Đăng nhập không thành công, xin vui lòng thử lại sau...",
  requestFailed: "Kết nối của bạn không ổn định. Vui lòng kiểm tra kết nối của bạn và thử lại.",

  close: "Tài khoản đã bị đóng ! Vui lòng liên hệ cấp trên của bạn để được tiếp tục...",
  suspend: "Tài khoản đã bị treo ! Vui lòng liên hệ cấp trên của bạn để được tiếp tục...",
  freeze: "Tài khoản của bạn đã bị đóng băng ! Vui lòng liên hệ cấp trên của bạn để được tiếp tục...",

  alphaNumOnly: "Chỉ sử dụng chữ và số",

  // vuelidate
  isRequired: "Vui lòng nhập một {fname}.",
  isMinValue: "{fname} phải có tối thiểu {fvalue}.",
  isMaxValue: "{fname} phải nhỏ hơn hoặc bằng {fvalue}.",
  isMinLength: "{fname} phải có ít nhất {fvalue} ký tự.",
  isMaxLength: "{fname} phải nhỏ hơn hoặc bằng {fvalue} ký tự.",
  isAlpha: "{fname} chỉ chấp nhận bảng chữ cái.",
  isAlphaNum: "{fname} chỉ chấp nhận chữ cái và số.",
  isNumeric: "{fname} chỉ chấp nhận numerics.",
  isEmail: "{fname} chấp nhận địa chỉ email hợp lệ.",
  isIpAddress: "{fname} chỉ chấp nhận địa chỉ IPv4 chỉ có giá trị.",
  isSameAs: "{fname} phải được giống như {fname2}.",
  isUrl: "{fname} hỉ chấp nhận URL.",
  containAlphaNum: "{fname} phải có ít nhất một chữ cái và một số.",
  selectOption: "Vui lòng chọn {fname}",
  notSameAs: "{fname} và {fname2} không thể giống nhau.",

  currPasswordRequired: "Mật khẩu hiện tại bắt buộc phải có!",
  newPasswordRequired: "Mật khẩu mới bắt buộc phải có!",
  confirmNewPasswordRequired: "Xác nhận mật khẩu mới bắt buộc phải có!",
  passwordsNotMatch: "Mật khẩu không giống nhau!",
  nickNameRequired: "Biệt danh là bắt buộc phải có!",

  startDateRequired: "Ngày bắt đầu là bắt buộc phải có!",
  endDateRequired: "Ngày kết thúc là bắt buộc phải có!",
  pageSizeRequired: "Kích thước trang là bắt buộc phải có!",
  pageNumberRequired: "Số trang là bắt buộc phải có!",
  sportsTypeRequired: "Loại thể thao là bắt buộc phải có!",

  workingDateRequired: "Ngày hoạt động là bắt buộc phải có!",
  leagueIdRequired: "Tên giải đấu là bắt buộc phải có!",
  isOutrightRequired: "Tên cược vô địch là bắt buộc phải có!",

  maxParlayTicket: "Đạt tối đa các trận đấu trong 1 lần cược xiên!",
  matchHide: "Trận đấu không tồn tại!",
  selectLeague: "Please select at least 1 league",
  liveCasinoDisabled: "Sòng bạc trực tiếp bị vô hiệu hóa",
  slotDisabled: "Máy xèng bị vô hiệu hóa",
  lotteryDisabled: "Xổ số bị vô hiệu hóa",
  MiniGameDisabled: "Trò chơi nhỏ đã bị vô hiệu hóa",
  EsportsDisabled: "Trò chơi thể thao điện tử bị vô hiệu hóa",
  currencyNotSupported: "Đơn vị tiền tệ không được hỗ trợ",
  game_maintenance: "Trò chơi đang bảo trì.",
  forbiddenAccess: "Truy cập Bị Cấm",
  invalidCurrency: "Tiền không hợp lệ đặt cược",
  connectionFailed: "Không thể liên kết hệ thống ví.",

  //tournament
  login_id_not_exists: "Đăng nhập không hợp lệ, vui lòng thử đăng nhập lại.",
  noMatchSelected: "Vui lòng chọn ít nhất 1 trận đấu.",
  invalidRoomRate: "Giá phòng không hợp lệ.",
  invalidRoomLimit: "Giới hạn phòng không hợp lệ.",
  invalidRoomPassword: "Mã PIN không hợp lệ. Mã PIN phải có 6 chữ số.",
  invalidPassword: "Mật khẩu không hợp lệ",
  roomPasswordRequired: "Mã PIN được yêu cầu.",
  minMatch: "Đã chọn tối thiểu 3 trận đấu.",
  maxMatch: "Tối đa {max} trận được chọn.",
  roomIdRequired: "ID phòng là bắt buộc.",
  roomTypeRequired: "Loại phòng được yêu cầu.",
  sessionTokenRequired: "Mã thông báo phiên là bắt buộc.",
  matchDateRequired: "Yêu cầu ngày khớp.",
  matchRequired: "Yêu cầu khớp.",
  roomLimitRequired: "Yêu cầu giới hạn phòng.",
  roomRateRequired: "Yêu cầu giá phòng.",
  minRoomRate: "Phí vào cửa phải bằng hoặc lớn hơn 10.",
  maxRoomRate: "Phí vào cửa phải bằng hoặc nhỏ hơn 1000.",
  minRoomLimit: "Số lượng Người chơi phải bằng hoặc nhiều hơn 3.",
  maxRoomLimit: "Số lượng Người chơi phải bằng hoặc nhỏ hơn 30.",
  invalidRoomType: "Loại phòng không hợp lệ.",
  invalidMatch: "Trận đấu không hợp lệ.",
  dataError: "Lỗi dữ liệu",
  memberExists: "Thành viên đã tồn tại.",
  invalidMember: "Thành viên không hợp lệ.",
  invalidleague: "Giải đấu không hợp lệ.",
  "createRoomFailed-1": "Tạo phòng thất bại 1.",
  "createRoomFailed-2": "Tạo phòng thất bại 2.",
  "createRoomFailed-3": "Tạo phòng thất bại 3.",
  invalidOperator: "Toán tử không hợp lệ.",
  roomFull: "Phòng đã đầy.",
  memberExists: "Thành viên đã tồn tại.",
  "joinFailed-1": "Tham gia phòng thất bại 1.",
  "joinFailed-2": "Không thể tham gia phòng 2.",
  IPJoinedBefore: "IP đã tham gia trước đó.",
  memberJoinedBefore: "Bạn đã tham gia trước đó, xin lưu ý rằng phòng miễn phí chung chỉ có thể tham gia một lần.",
  roomNotExists: "Phòng không tồn tại.",
  roomIsPublicFree: "Phòng công khai miễn phí.",
  roomEndedOrCancelled: "Phòng đã kết thúc hoặc bị hủy.",
  roomEnded: "Phòng đã hết.",

  matchLowerMin: "Đã xảy ra lỗi so khớp tối thiểu thấp hơn.",
  matchOverMax: "Xảy ra lỗi so khớp vượt quá tối đa.",
  pointsOverLimit: "Xảy ra lỗi vượt quá giới hạn điểm.",
  roomOverMax: "Đã xảy ra lỗi vượt quá dung lượng phòng tối đa.",
  invalidRoom: "Phòng không hợp lệ.",
  roomLimitOverMax: "Đã xảy ra lỗi giới hạn phòng trên mức tối đa.",
  rateLowerMin: "Đã xảy ra lỗi xếp hạng tối thiểu thấp hơn.",
  rateOverMax: "Xảy ra lỗi đánh giá trên giá trị tối đa.",

  liveMatchNotAllowed: "Trận đấu trực tiếp không được phép.",
  roomLimitLowerMin: "Đã xảy ra lỗi tối thiểu giới hạn phòng thấp hơn.",
  roomClosed: "Phòng đã đóng.",
  leagueLeagueExists: "Giải đấu có tồn tại.",
  roomExists: "Không cho phép tạo nhiều hơn 1 phòng riêng.",
  roomExists: "Không cho phép tạo nhiều hơn 1 phòng riêng.",
  betExists: "Cược đã tồn tại.",
  roomClosedNotAllowed: "Không cho phép đóng phòng.",
  leagueMatchExists: "Trận đấu giải đấu tồn tại.",
  account_id_required: "ID tài khoản là bắt buộc.",
  agent_comm_rate_required: "Tỷ lệ hoa hồng đại lý là bắt buộc.",
  agent_id_required: "ID đại lý là bắt buộc.",
  bet_amount_required: "Yêu cầu số tiền đặt cược.",
  bet_id_required: "ID đặt cược là bắt buộc.",
  credit_amount_required: "Số tiền tín dụng được yêu cầu.",
  currency_required: "Đơn vị tiền tệ được yêu cầu.",
  debit_amount_required: "Số tiền ghi nợ là bắt buộc.",
  duplicate_credit_record: "Hồ sơ tín dụng trùng lặp.",
  master_comm_rate_required: "Yêu cầu tỷ lệ hoa hồng chính.",
  master_id_required: "Cần có ID chính.",
  member_id_required: "ID thành viên là bắt buộc.",
  member_wallet_not_exists: "Ví thành viên không tồn tại.",
  permission_denied: "Quyền bị từ chối.",
  rate_required: "Tỷ lệ được yêu cầu.",
  result_exists: "Kết quả đã tồn tại.",
  room_id_required: "Cần có ID phòng.",
  s_senior_comm_rate_required: "Yêu cầu tỷ lệ hoa hồng cấp cao.",
  s_senior_id_required: "Cần có ID cấp cao.",
  senior_comm_rate_required: "Tỷ lệ hoa hồng cấp cao là bắt buộc.",
  senior_id_required: "ID cao cấp là bắt buộc.",
  shareholder_comm_rate_required: "Tỷ lệ hoa hồng cổ đông là bắt buộc.",
  shareholder_id_required: "ID cổ đông là bắt buộc.",
  transfer_id_required: "ID chuyển khoản là bắt buộc.",
  minBetAmount: "Đã xảy ra lỗi về số tiền đặt cược tối thiểu.",
  tournamentDisabled: "Giải đấu bị vô hiệu hóa, vui lòng kiểm tra liên hệ với tuyến trên của bạn.",
  // tournamentDisabled: "Sắp có giải đấu. Xin vui lòng ở lại điều chỉnh!",
  marketTypeRequired: "Loại thị trường là bắt buộc.",
  invalidMarketType: "Loại thị trường không hợp lệ được cung cấp.",
  marketTypeChanged: "Phiếu cược đã bị xóa do thay đổi loại thị trường.<br />Vui lòng chọn lại từ thị trường.",
  changeStakeMin: "Số tiền đặt cược đầu vào đã bị thay đổi do giới hạn MIN.",
  changeStakeMax: "Số tiền đặt cược đầu vào đã bị thay đổi do giới hạn MAX.",
  betNotExists: "Vui lòng đặt cược hợp lệ để tham gia giải đấu.",
  cashOutUnavailable: "Rút tiền không khả dụng.",
  errorCashoutAmount: "Rút tiền đang được cập nhật...",
  freeRoomNeedBet: "Vui lòng đặt cược hợp lệ để truy cập phòng miễn phí.",

  startTimeRequired: "Bắt buộc phải có thời gian bắt đầu.",
  endTimeRequired: "Bắt buộc phải có thời gian kết thúc.",
  oddsTypeIDRequired: "Bắt buộc phải có loại tỷ lệ cược.",
  missionRequired: "Bắt buộc phải có phí hoa hồng.",
  requestTimeRequired: "Bắt buộc phải có thời gian yêu cầu.",
  statusRequired: "Bắt buộc phải có trạng thái.",
  invalidStartTime: "Thời gian bắt đầu không hợp lệ.",
  invalidEndTime: "Thời gian kết thúc không hợp lệ.",
  invalidOddsTypeID: "Loại tỷ lệ cược không hợp lệ.",
  invalidCommission: "Phí hoa hồng không hợp lệ.",
  invalidRequestTime: "Thời gian yêu cầu không hợp lệ.",
  invalidStatus: "Trạng thái không hợp lệ",
  invalidAlgoMatchInfo: "Thị trường này đã đóng, vui lòng thử các thị trường khác. (-101)",
  invalidAlgoSliderLeagueInfo: "Thông tin giải đấu không hợp lệ.",
  invalidAlgoSliderMinutesWeight: "Trọng lượng phút không hợp lệ.",
  invalidAlgoSliderBetType: "Loại cược không hợp lệ.",
  invalidRTSRunningScoreDetails: "Chi tiết điểm số hiện tại (RTS) không hợp lệ.",
  invalidProviderGoalTimeLine: "Dòng thời gian ghi bàn của nhà cung cấp không hợp lệ.",
  invalidSliderTimeRange: "Khoảng thời gian không hợp lệ.",
  invalidMOMatchOdds: "Tỷ lệ cược trận đấu đang được cập nhật...",
  invalidProviderSlider: "Thông tin TM không hợp lệ.",
  invalidCombineBetTypeAndOddsFormat: "Loại cược kết hợp và định dạng tỷ lệ cược không hợp lệ.",
  invalidMatchInformation: "Thông tin trận đấu không hợp lệ.",
  marketClose: "Thị trường này đã đóng cửa, vui lòng thử các thị trường khác.",
  error: "Lỗi"
};
